import React from 'react';
import OccasionPageLayout from 'components/OccasionPageLayout';
import { faqData } from 'data/occasionPages';

const FAQPage: React.FC = () => <OccasionPageLayout data={faqData} />;

export default FAQPage;
